<template>
  <v-text-field :value="priceStr" @blur="onBlur" v-bind="$attrs" :error="!!error"></v-text-field>
</template>

<script>
import { formatPrice, integerOfPrice } from '@/plugins/price'

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: false,
    },
  },
  data() {
    return { error: null, updated: false }
  },
  computed: {
    priceStr() {
      let value = this.updated ? 0 : this.value
      return formatPrice(value, this.currency)
    },
  },
  methods: {
    onBlur(event) {
      let price
      try {
        price = integerOfPrice(event.target.value, this.currency)
      } catch (error) {
        this.error = String(error)
        return
      }
      this.error = null
      this.$emit('input', price)
      this.$emit('blur', event)
      // 末尾小数被舍弃时，确保触发输入框内容更新
      this.updated = true
      this.$nextTick(() => {
        this.updated = false
      })
    },
  },
}
</script>

<style></style>
